import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { inventoryAPI } from '../../services';
import { toast } from 'react-toastify';

export default function TransferStockModal({ show, onHide, fromBranchId, branches, materials, onSuccess }) {
  const [formData, setFormData] = useState({
    to_branch_id: '',
    material_id: '',
    quantity: '',
    note: '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      setFormData({ to_branch_id: '', material_id: '', quantity: '', note: '' });
    }
  }, [show]);

  const handleChange = (field, value) =>
    setFormData((prev) => ({ ...prev, [field]: value }));

  const selectedMaterial = materials?.find((m) => m.id === formData.material_id);
  const targetBranches = (branches || []).filter((b) => b.id !== fromBranchId);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.to_branch_id) { toast.error('Vui lòng chọn chi nhánh nhận'); return; }
    if (!formData.material_id) { toast.error('Vui lòng chọn NVL'); return; }
    if (!formData.quantity || Number(formData.quantity) <= 0) { toast.error('Số lượng phải lớn hơn 0'); return; }
    try {
      setLoading(true);
      await inventoryAPI.transferStock({
        from_branch_id: fromBranchId,
        to_branch_id: formData.to_branch_id,
        material_id: formData.material_id,
        quantity: Number(formData.quantity),
        note: formData.note.trim() || undefined,
      });
      toast.success('Đã chuyển kho thành công');
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error(err?.message || 'Không thể chuyển kho');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Chuyển kho giữa chi nhánh</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Chi nhánh nhận <span className="text-danger">*</span></Form.Label>
            <Form.Select value={formData.to_branch_id} onChange={(e) => handleChange('to_branch_id', e.target.value)} required>
              <option value="">-- Chọn chi nhánh --</option>
              {targetBranches.map((b) => (
                <option key={b.id} value={b.id}>{b.name}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Nguyên vật liệu <span className="text-danger">*</span></Form.Label>
            <Form.Select value={formData.material_id} onChange={(e) => handleChange('material_id', e.target.value)} required>
              <option value="">-- Chọn NVL --</option>
              {(materials || []).filter((m) => m.is_active !== false).map((m) => (
                <option key={m.id} value={m.id}>{m.name} ({m.unit})</option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Số lượng {selectedMaterial ? `(${selectedMaterial.unit})` : ''} <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number" min="0.001" step="0.001"
              value={formData.quantity}
              onChange={(e) => handleChange('quantity', e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Ghi chú</Form.Label>
            <Form.Control
              as="textarea" rows={2}
              value={formData.note}
              onChange={(e) => handleChange('note', e.target.value)}
              placeholder="Lý do chuyển kho..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>Hủy</Button>
          <Button variant="warning" type="submit" disabled={loading}>
            {loading ? 'Đang chuyển...' : 'Chuyển kho'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
